import { Link } from 'react-router-dom';
import { GraduationCap, Handshake, ArrowRight, ShieldCheck } from 'lucide-react';

// Portes 1 et 2 de l'accueil (la 3e, « J'ai déjà un compte », est le formulaire de connexion)
export const PortesAccueil = ({ onPro }) => (
  <div className="space-y-3" data-testid="portes-accueil">
    <Link
      to="/inscription-candidat"
      className="group block rounded-2xl bg-[#8DC63F] p-5 text-white shadow-lg shadow-[#8DC63F]/25 transition-transform duration-200 hover:-translate-y-0.5 animate-in fade-in slide-in-from-bottom-2"
      data-testid="inscription-candidat-link"
    >
      <div className="flex items-start gap-4">
        <div className="rounded-xl bg-white/20 p-3 shrink-0">
          <GraduationCap className="h-7 w-7" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wider text-white/80">Candidat</p>
          <p className="text-lg sm:text-xl font-display font-bold leading-tight">Je veux me former chez FISL</p>
          <p className="mt-2 flex items-start gap-1.5 text-sm text-white/95" data-testid="intro-candidat">
            <ShieldCheck className="h-4 w-4 mt-0.5 shrink-0" />
            Pour candidater à une formation FISL, vous devez commencer par créer un compte sécurisé.
          </p>
        </div>
        <ArrowRight className="h-5 w-5 mt-1 shrink-0 transition-transform duration-200 group-hover:translate-x-1" />
      </div>
    </Link>

    <button
      type="button"
      onClick={onPro}
      className="group w-full rounded-2xl border-2 border-slate-200 bg-white p-5 text-left transition-colors duration-200 hover:border-[#0F172A] animate-in fade-in slide-in-from-bottom-2"
      data-testid="porte-pro"
    >
      <div className="flex items-start gap-4">
        <div className="rounded-xl bg-[#0F172A] p-3 text-white shrink-0">
          <Handshake className="h-7 w-7" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Professionnel / partenaire</p>
          <p className="text-lg sm:text-xl font-display font-bold leading-tight text-[#0F172A]">Je travaille avec FISL</p>
          <p className="mt-1 text-sm text-slate-500">Formateur, évaluateur, tuteur, entreprise, moniteur VNM (FISL), responsable pédagogique</p>
        </div>
        <ArrowRight className="h-5 w-5 mt-1 shrink-0 text-slate-400 transition-transform duration-200 group-hover:translate-x-1" />
      </div>
    </button>
  </div>
);
